<script setup>
import { cn } from '@/lib/utils';
import { cardVariants } from '.';

const props = defineProps({
  class: { type: null, required: false },
  variant: { type: null, required: false },
});
</script>

<template>
  <div
    :class="
      cn(
        cardVariants({ variant }),
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
